import { Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
@Pipe({
  name: 'formatPhone'
} )
export class FormatPhonePipe implements PipeTransform {

  constructor(
    private authService: AuthService
  ){}
  
  areaCode: string = '';
  
  transform( value: string, args?: any ): any {
    if ( ! value ) return;
    
    if ( this.authService.currentUser ){
      this.areaCode = this.authService.currentUser.areaCode;
    }

    let val = '' + value;
    val = val.replace(/\D/g,'');
    
    let indexOfAreaCode = val.indexOf( this.areaCode );
    let sliceIndex: number;

    // 1. normalize number
    if ( indexOfAreaCode >= 0 && indexOfAreaCode <= 2 ) { // if has area code
      val = val.substring(0,13 + indexOfAreaCode ); // First 13 to indexOfAreaCode digits of input only
      val = '0' + val.substring(3,13);
    } else {
      val = val.replace(/\D/g,'').substring(0,10); // First 10 digits of input only
    }
    // 2. add hyphen
    if ( val.indexOf( '05' ) === 0 || val.indexOf('0') !== 0 ){
      sliceIndex = 3;
    } else {
      sliceIndex = 2;
    }
    val = val.substring( 0, sliceIndex ) + '-' + val.substring( sliceIndex, val.length );

    return val;

  }

}
